import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import PropTypes from 'prop-types'

const SHAPE_CLIP_PATHS = {
  diamond: 'polygon(50% 0%,100% 50%,50% 100%,0% 50%)',
  circle: 'circle(50%)',
  square: undefined,
  triangle: 'polygon(50% 0%,100% 100%,0% 100%)'
}

const rowStyle = { display: 'flex', alignItems: 'center', gap: 6 }
const valueStyle = { marginLeft: 'auto', fontWeight: 600 }

function DefaultTooltipContent ({ item, valueFormatter, allocationColor, outOfToleranceColor, targetColor, targetShape, thresholdColor }) {
  const allocColor = item.color || (item.isOOT ? outOfToleranceColor : allocationColor)
  const clipPath = SHAPE_CLIP_PATHS[targetShape] || SHAPE_CLIP_PATHS.diamond

  return (
    <div>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{item.name}</div>

      <div style={rowStyle}>
        <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 2, background: allocColor }} />
        <span>Allocation</span>
        <span style={valueStyle}>{valueFormatter(item.actual)}</span>
      </div>

      <div style={rowStyle}>
        <span style={{ display: 'inline-block', width: 10, height: 10, background: targetColor, clipPath }} />
        <span>Target</span>
        <span style={valueStyle}>{valueFormatter(item.target)}</span>
      </div>

      {item.bandStart !== null && item.bandEnd !== null && (
        <>
          <div style={{ ...rowStyle, opacity: 0.7 }}>
            <span style={{ display: 'inline-block', width: 10, height: 4, borderRadius: 1, background: thresholdColor }} />
            <span>Min Threshold</span>
            <span style={valueStyle}>{valueFormatter(item.bandStart)}</span>
          </div>
          <div style={{ ...rowStyle, opacity: 0.7 }}>
            <span style={{ display: 'inline-block', width: 10, height: 4, borderRadius: 1, background: thresholdColor }} />
            <span>Max Threshold</span>
            <span style={valueStyle}>{valueFormatter(item.bandEnd)}</span>
          </div>
        </>
      )}
    </div>
  )
}

DefaultTooltipContent.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    actual: PropTypes.number,
    target: PropTypes.number,
    bandStart: PropTypes.number,
    bandEnd: PropTypes.number,
    isOOT: PropTypes.bool,
    color: PropTypes.string
  }).isRequired,
  valueFormatter: PropTypes.func.isRequired,
  allocationColor: PropTypes.string,
  outOfToleranceColor: PropTypes.string,
  targetColor: PropTypes.string,
  targetShape: PropTypes.string,
  thresholdColor: PropTypes.string
}

export default DefaultTooltipContent

export function renderDefaultTooltip (item, opts) {
  return renderToStaticMarkup(<DefaultTooltipContent item={item} {...opts} />)
}
